import React, { useMemo } from 'react';

import { Chip, Stack, Typography } from '@mui/material';

import { getRoomRateHref } from '../../shared/roomRateHref';
import ManageRoomRateSurchargesAction from '../surcharges/ManageRoomRateSurchargesAction';

import { buildRoomRateGroups } from './egsRoomMatcher';

interface Props {
  emptyMessage: string;
  propertyId?: string;
  roomRateIds: Array<string>;
  roomTypes: Array<App.RoomType>;
  vendorId?: string;
}

export default function EgsRoomRateList({ emptyMessage, propertyId, roomRateIds, roomTypes, vendorId }: Props) {
  const groups = useMemo(
    () =>
      buildRoomRateGroups(roomRateIds, roomTypes).map((group) => ({
        ...group,
        roomRates: group.roomRates.map((roomRate) => ({
          ...roomRate,
          href: getRoomRateHref({
            propertyId,
            roomRateId: roomRate.roomRateId,
            roomTypeId: group.roomTypeId,
            vendorId,
          }),
        })),
      })),
    [propertyId, roomRateIds, roomTypes, vendorId],
  );

  if (groups.length === 0) {
    return (
      <Typography color="text.secondary" variant="body2">
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <Stack spacing={1}>
      {groups.map((group) => (
        <Stack key={group.roomTypeId} alignItems="baseline" direction="row" flexWrap="wrap" gap={0.5}>
          <Typography fontWeight={600} sx={{ mr: 0.5 }} variant="body2">
            {group.roomTypeName}
          </Typography>
          {group.roomRates.map((roomRate) => (
            <Stack key={roomRate.roomRateId} alignItems="center" direction="row">
              <Chip label={roomRate.ratePlanName} size="small" variant="outlined" />
              <ManageRoomRateSurchargesAction href={roomRate.href} />
            </Stack>
          ))}
        </Stack>
      ))}
    </Stack>
  );
}
